import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import CardComp from "./CardComp";
import CeoMsg from "./CeoMsg";
import Cibi from "./Cibi";
import Network from "./Company/Network";
import Sourcing from "./Company/Sourcing";
import Industry from "./Company/Industry";
import ExpWithPicLeft from "../ExpWithPicLeft";
import ExpWithPicRight from "../ExpWithPicRight";
import ESG from "./Company/ESG";
import PageTop from "../PageTop";

const useStyles = makeStyles({
  product__inner: { paddingBottom: "100px" },
  card: {
    maxWidth: 275,
    paddingTop: "27px",
    paddingBottom: "25px",
    textAlign: "center",

    cursor: "pointer",
    "&:hover": {
      // color: "grey",
      boxShadow:
        "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
    },
  },
  name: { fontWeight: "bold" },
  teambg: {
    width: "100%",
    height: "400px",
    color: "#424242",
    backgroundRepeat: "none",
    backgroundSize: "cover",
    backgroundPosition: "right 12% bottom 40%",
    backgroundImage: `url("img/teambg.png")`,
    display: "flex",
    alignItems: "center",
  },
});

const Company = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  return (
    <>
      <PageTop
        bottom="55"
        title={t("heslet_us_llc")}
        smallTitle={t("heslet_us_llc2")}
        img="img/teambg.png"
      />

      <div>
        <Box sx={{ display: "flex", justifyContent: "center", pt: 6 }}>
          <ExpWithPicLeft
            imgUrl="img/yaytg623921.jpg"
            smallTitle={t("unique")}
            title={t("tech")}
            content={t("company_tech")}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ExpWithPicRight
            imgUrl="/img/bg9.jpg"
            smallTitle={t("our_mission_small")}
            title={t("our_mission")}
            content={t("our_mission_exp")}
          />
        </Box>
      </div>
      <Network />
      <Sourcing />
      <Industry />
      <ESG />

      <div className="css_team">
        <Container>
          <Box className={classes.product__inner} sx={{ pt: 7 }}>
            <section id="team"></section>
            <Box
              variant="h4"
              className="title"
              sx={{ pt: 13, textAlign: "center" }}
            >
              Our Team
            </Box>
            <Grid
              container
              spacing={5}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "40px",
              }}
            >
              <Grid item md={4}>
                <CardComp
                  name={t("company_team1")}
                  position="CEO/CTO"
                  desc={t("company_team2")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team3")}
                  position="Domestic Sales"
                  desc={t("company_team4")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team5")}
                  position="Quality Manager"
                  desc={t("company_team6")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team7")}
                  position="Marketing Strategist"
                  desc={t("company_team8")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team9")}
                  position="MD"
                  desc={t("company_team10")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team11")}
                  position="Overseas Sales"
                  desc={t("company_team12")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team13")}
                  position="PR/PM"
                  desc={t("company_team14")}
                />
              </Grid>
              <Grid item md={4}>
                <CardComp
                  name={t("company_team15")}
                  position="Web Designer"
                  desc={t("company_team16")}
                />
              </Grid>
            </Grid>
          </Box>
          <CeoMsg />
        </Container>
        <Cibi />
      </div>
    </>
  );
};

export default Company;
